import { CampaignBriefingController } from './campaign-briefing.controller'

function campaignBriefing () {
  return {
    scope: {
      campaign: '='
    },
    restrict: 'E',
    templateUrl: '/campaigns/directives/campaign-briefing/campaign-briefing.html?$$REVISION$$',
    controller: CampaignBriefingController
  }
}

export { campaignBriefing }
